<template>
  <div>
    <b-card class="mt-2">
      <b-row>
        <b-col md="6">
          <label><b>Nombres: *</b></label>
          <b-form-input
            v-model="nombres"
            :class="{'input-error': errors.nombres}"
            required
          ></b-form-input>
        </b-col>
        <b-col md="6">
          <label><b>Apellidos: *</b></label>
          <b-form-input
            v-model="apellidos"
            :class="{'input-error': errors.apellidos}"
            required
          ></b-form-input>
        </b-col>
      </b-row>
      <b-row class="mt-1">
        <b-col md="6">
          <label><b>Tipo de Identificación: *</b></label>
          <v-select
            v-model="tipoIdent"
            :options="opsTipoIdent"
            label="text"
            :class="{'input-error': errors.tipoIdent}"
            required
          />
        </b-col>
        <b-col md="6">
          <label><b>Identificación: *</b></label>
          <b-form-input
            v-model="identificacion"
            :class="{'input-error': errors.identificacion}"
            :maxlength="tipoIdent.value === '1' ? 10 : null"
            @input="validarIdentificacion"
            required
          />
        </b-col>
      </b-row>
      <b-row class="mt-1">
        <b-col md="4">
          <label><b>Teléfono: *</b></label>
          <b-form-tags
            v-model="celular"
            :input-attrs="{ 'aria-describedby': 'tags-validation-help' }"
            :tag-validator="tagValidator"
            separator=" "
            input-type="number"
            placeholder="099999999"
            :class="{'input-error': errors.celular}"
            required
          />
        </b-col>

        <b-col md="4">
          <label><b>Correo: *</b></label>
          <b-form-input
            v-model="email"
            :class="{'input-error': errors.email}"
            required
          />
        </b-col>

      
        <b-col md="4">
          <label><b>Fecha Nacimiento: *</b></label>
          <flat-pickr
            class="form-control"
            v-model="fechaNacimiento"
            :class="{'input-error': errors.fecnac}"
            locale="es" 
            required
          />
        </b-col>
      </b-row>

      <b-row class="mt-4">
        <div style="width: 90%;" class="text-right">
          <b-button variant="success" @click="crearPersona">
            Registrar persona
          </b-button>
        </div>
      </b-row>

    </b-card>
  </div>
</template>
  
<script>
  
import { BootstrapVue } from 'bootstrap-vue';
import actions from '@/assets/utils/utils'
import vSelect from 'vue-select'
import axios from 'axios';
import rutas from '@/assets/utils/rutas.json';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
  
export default {
  name : "CrearPersona",
  
  components: {
    ...BootstrapVue.components,
    vSelect,
    flatPickr
  },

  
  mounted() {
    actions.setearTitulo("Crear Persona");
  }, 

  data() {
      
      return {
          opsTipoIdent: [
      { value: '0', text: 'RUC' },
      { value: '1', text: 'Cedula' },
      { value: '2', text: 'Passporte' }
    ],    
          identifiaciones : null,
          nombres : null,
          apellidos : null,
          tipoIdent : { value: '1', text: 'Cedula' },
          identificacion : null,
          celular : [],
          email : null,
          fechaNacimiento : null,

          errors: {
              nombres: false,
              apellidos: false,
              tipoIdent: false,
              identificacion: false,
              celular: false,
              email: false,
          }
      }
  },

  created(){
    this.fetchPersonas()
  },

  methods : {
    async fetchPersonas(search = '') {
      const query = `
        query MyQuery($search: String) {
          allPersona(search: $search) {
            correo
            telefono
            identificacion
            primerApellido
            primerNombre
            primerApellido
            id
          }
        }
      `;

      try {
        const response = await axios.post(rutas.axios + "api", {
          query,
          variables: { search }
        });

        // console.log(response.data);
        const personas = response.data.data.allPersona;

        const identificaciones = [];
        personas.forEach(persona => {
          identificaciones.push(persona.identificacion);
        });

        this.identificaciones = identificaciones
        
      } catch (error) {
        console.error("Error buscando personas:", error.response ? error.response.data : error.message);
      }
    },

    validarIdentificacion() {
      if (this.tipoIdent === '1' && this.identificacion.length > 10) {
        this.identificacion = this.identificacion.slice(0, 10);
      }
    },

    validarCampos() {
      let isValid = true;

      // Resetear errores
      this.errors = {
        nombres: false,
        apellidos: false,
        tipoIdent: false,
        identificacion: false,
        celular: false,
        email: false,
        fecnac: false
      };

      // Validar cada campo
      if (!this.nombres) {
        this.errors.nombres = true;
        isValid = false;
      }
      if (!this.apellidos) {
        this.errors.apellidos = true;
        isValid = false;
      }
      if (!this.tipoIdent) {
        this.errors.tipoIdent = true;
        isValid = false;
      }

      if (!this.identificacion || this.identificacion.length < 10 ||this.identificacionrepetida ) {
        this.errors.identificacion = true;
        isValid = false;
      }

      if (!this.celular.length) {
        this.errors.celular = true;
        isValid = false;
      }
      if (!this.email) {
        this.errors.email = true;
        isValid = false;
      }
      if (!this.fechaNacimiento) {
        this.errors.fecnac = true;
        isValid = false;
      }

      if (!isValid ) {
        const identRepetida = `Ingrese una identificacion que no exista`;
        const mensaje = 'Por favor, complete todos los campos obligatorios.';
        this.$swal.fire({
          icon: 'error',
          title: 'Error',
          text: this.identificacionrepetida ? identRepetida : mensaje
        });
      }
      return isValid;
    },

    tagValidator(tag) {
      const isValid = /^\d+$/.test(tag) && tag.length < 11
      this.tagError = isValid ? '' : 'Solo se permiten valores numéricos hasta de 10 caracteres'
      return isValid
    },

    async crearPersona() {
      if (!this.validarCampos()) return;

      const query = `
        mutation crearPersona (
          $nombres: String!,
          $apellidos: String!,
          $tipoIdent: String!,
          $identificacion: String!,
          $telefono:String!,
          $fechaNacimiento:String!,
          $sexo:String!,
          $email:String!,
          $nacionalidad:String!,
          $nivelEducacion:String!,
          $profesion:String!,
          $pueKichwa:String!,
          $tipoBono:String!,
          $nacioEtni:String!,
          $callePrincipal: String!,
          $calleSecundaria: String!,
          $referencia: String!,
          $barrio: String!,
          $urlIdentificacion:String!,
          $urlCarnet:String,
          $esDiscapacitado:Int
        ){
          crearPersona(
            nombres:$nombres
            apellidos:$apellidos
            tipoIdent:$tipoIdent
            identificacion:$identificacion
            telefono:$telefono
            fechaNacimiento:$fechaNacimiento
            sexo:$sexo
            email:$email
            nacionalidad:$nacionalidad
            nivelEducacion:$nivelEducacion
            profesion:$profesion
            pueKichwa:$pueKichwa
            tipoBono:$tipoBono
            nacioEtni:$nacioEtni
            callePrincipal:$callePrincipal
            calleSecundaria:$calleSecundaria
            referencia:$referencia
            barrio:$barrio
            urlIdentificacion:$urlIdentificacion
            esDiscapacitado:$esDiscapacitado
            urlCarnet: $urlCarnet
          ){
            persona {
              token,id
            }
            status,
            message
          }
        }
      `;
      
      const variables = {
        nombres: this.nombres,
        apellidos: this.apellidos,
        nacioEtni: '',
        tipoIdent: this.tipoIdent? this.tipoIdent.value : '1' ,
        identificacion: this.identificacion,
        telefono: this.celular.join(','),
        sexo: '0',
        email: this.email,
        fechaNacimiento: this.fechaNacimiento ? this.fechaNacimiento : '21-08-2008',
        nacionalidad: '',
        nivelEducacion: '',
        profesion: '',
        pueKichwa: '',
        tipoBono: '',
        barrio: '1', 
        callePrincipal: '...',
        calleSecundaria: '',
        referencia: '',
        urlIdentificacion:'',
        urlCarnet:'',
        esDiscapacitado: 0,
        identificacionrepetida: false,
      };

      try {
        const response = await axios.post(rutas.axios + 'api', { query, variables });

        if (response.status === 200) {
          if (response.data.data.crearPersona.status === 'success') {
            const { token, id } = response.data.data.crearPersona.persona;
            if (id > 0) {
              this.$swal.fire({
                icon: 'success',
                title: 'Exito',
                text: `Persona creada correctamente .`,
              });
              this.$router.push({ name: 'consultar_personas' })
            } else {
              this.$swal.fire({
                icon: 'error',
                title: 'Error',
                text: `Error al crear la persona ${response.data.data.crearPersona.message} .`,
              });
            }
          }
        } else {
          this.$swal.fire({
            icon: 'error',
            title: 'Error',
            text: `Presenta el siguiente error ${response.data.data.crearPersona.message} .`,
          });
        }
  
      } catch (err) {
        this.$swal.fire({
          icon: 'error',
          title: 'Error',
          text: `Presenta el siguiente error ${err} .`,
        });
        console.log(err);
        return 0;
      }
    }
  },

  watch: {
    identificacion(newVal) {
      if (newVal.length > 9) {
        if(this.identificaciones.includes(newVal)){
          this.$toast.error("La identificacion ya fue ingresada anteriormente!");
          this.identificacionrepetida = true
        }else{
          this.$toast.success("Identificacion correcta");
          this.identificacionrepetida = false
        }
      }
    },
  }

}
    
  
</script>

<style>
  .input-error {
    border-color: red !important;
  }
</style>
  
